function updateCartTotalCountInCartPage() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const cartTotalCount = parseInt(cart.item_count);
      document.querySelector('.mobile-cart-count').innerText = cartTotalCount;
      if (cartTotalCount > 0) {
        document.querySelector('.navbar-nav--desktop-main')?.classList.add('cart-highlight');
        document.querySelector('.mobile-cart-count')?.classList.add('active');
      } else {
        document.querySelector('.navbar-nav--desktop-main')?.classList.remove('cart-highlight');
        document.querySelector('.mobile-cart-count')?.classList.remove('active');
      }
    })
    .catch((e) => {
      console.error('Error fetching cart data:', e);
    });
}

updateCartTotalCountInCartPage();
